import React from 'react';
import { API } from '../../lib/adminApi';
import { FLAVOURS } from '../../data/mock';
import { AlertTriangle, CheckCircle2, Film } from 'lucide-react';

const TZ = 'Europe/Athens';
const dayKey = (d) => new Date(d).toLocaleDateString('en-CA', { timeZone: TZ });
const flavourName = (f) => (f === 'mix' ? 'MIX BOX' : FLAVOURS[f]?.name);

export default function SocialCalendar({ posts }) {
  const days = Array.from({ length: 14 }, (_, i) => new Date(Date.now() + i * 86400000));
  const scheduled = posts.filter((p) => p.scheduled_at);

  return (
    <div className="bg-[#0d0d0d] border border-white/10 rounded-xl p-5 space-y-4" data-testid="social-calendar">
      <div>
        <h3 className="text-white font-bold">Calendario post (prossimi 14 giorni)</h3>
        <p className="text-white/40 text-xs mt-1">Orari in ora greca. I post programmati escono da soli (controllo ogni 15 minuti) quando Meta è collegato.</p>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-7 gap-2">
        {days.map((d) => {
          const k = dayKey(d);
          const items = scheduled.filter((p) => dayKey(p.scheduled_at) === k);
          return (
            <div key={k} className="min-h-[110px] rounded-lg border border-white/10 bg-black/40 p-2" data-testid={`calendar-day-${k}`}>
              <p className="text-[11px] uppercase tracking-wider text-white/40">
                {d.toLocaleDateString('it-IT', { timeZone: TZ, weekday: 'short', day: 'numeric', month: 'short' })}
              </p>
              <div className="mt-2 space-y-1.5">
                {items.map((p) => (
                  <div key={p.id} className="flex items-center gap-1.5 text-[11px] text-white/80" data-testid="calendar-item">
                    {p.image_path
                      ? <img src={`${API}/social/media/${p.id}.jpg`} alt="" className="w-7 h-7 rounded object-cover shrink-0" />
                      : <div className="w-7 h-7 rounded bg-white/10 shrink-0" />}
                    <span className="truncate" style={{ color: FLAVOURS[p.flavour]?.primary }}>
                      {new Date(p.scheduled_at).toLocaleTimeString('it-IT', { timeZone: TZ, hour: '2-digit', minute: '2-digit' })} {flavourName(p.flavour)}
                    </span>
                    {p.kind === 'video' && <Film size={11} className="shrink-0 text-white/50" />}
                    {p.status === 'published' && <CheckCircle2 size={11} className="shrink-0 text-green-400" />}
                    {p.schedule_error && <AlertTriangle size={11} className="shrink-0 text-yellow-400" title={p.schedule_error} />}
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
